module.exports = __webpack_public_path__ + "img/bg_avatar_female_69.74b91fff.png";